import { createBrowserClient } from '@supabase/ssr';

/**
 * Create a Supabase client for use in browser/client components.
 *
 * This client handles session management automatically via cookies.
 *
 * Usage:
 *   const supabase = createClient();
 *   const { data: { session } } = await supabase.auth.getSession();
 */
export function createClient() {
  return createBrowserClient(
    process.env['NEXT_PUBLIC_SUPABASE_URL']!,
    process.env['NEXT_PUBLIC_SUPABASE_PUBLISHABLE_KEY']!
  );
}
